import React from 'react';

import {
	AuthenticatorBlock,
	Box,
	Button,
	ComposableTypography,
	Loader,
	RoundIcon,
	Skeleton,
	Spacer,
	Typography,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { NavCloseO } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { Link } from '@components';
import { LEFT_PANEL_WIDTH } from '@constants';
import { rem } from '@helpers';

import { useAuthenticatorHelper } from './authenticatorFooter.helper';

export const AuthenticatorFooter: React.FC = () => {
	const {
		resources,
		colorPalette,
		showAuthentication,
		canRequestNewCode,
		buttonDisableValidate,
		showMessageError,
		authenticationTypeLoading,
		authenticationMessageLoading,
		requestAuthentication,
		onClickToNavigate,
		onButtonClick,
		onChangeValue,
		setToken,
		clearInformation,
	} = useAuthenticatorHelper();

	return (
		<Box
			styles={{
				position: 'fixed',
				bottom: 0,
				width: `calc(100vw - ${rem(LEFT_PANEL_WIDTH)})`,
				height: showAuthentication ? rem(185) : rem(114),
				zIndex: 100,
				background: colorPalette.color_01[70],
			}}
		>
			{authenticationMessageLoading && (
				<Box
					styles={{
						justifyContent: 'center',
						alignItems: 'center',
						height: '100%',
						flexGrow: 1,
						flexDirection: 'column',
					}}
				>
					<Spacer vertical={87} />
					<Loader height={100} width={100} />
				</Box>
			)}
			{!authenticationTypeLoading && !authenticationMessageLoading && showAuthentication && (
				<Box
					styles={{
						justifyContent: 'space-between',
						width: '100%',
						margin: rem(0, 80),
						paddingBottom: rem(24),
					}}
				>
					<Box
						styles={{
							paddingTop: showMessageError ? rem(28) : 0,
						}}
					>
						<AuthenticatorBlock
							title={resources.authenticationTitle}
							description={resources.description}
							mode={'sms'}
							onChange={onChangeValue}
							onSubmit={(text) => {
								setToken(text);
							}}
							errorMessage={showMessageError ? resources.errorMessage : undefined}
						/>
					</Box>
					<Box
						styles={{
							alignItems: 'center',
						}}
					>
						<Box
							styles={{
								flexDirection: 'column',
								alignItems: 'flex-end',
							}}
						>
							<Box>
								<RoundIcon
									onPress={clearInformation}
									size="medium"
									mode="custom"
									icon={{
										source: NavCloseO,
										svgProps: {
											width: rem(11),
											height: rem(11),
										},
									}}
									color="transparent"
								/>
							</Box>
							<Spacer vertical={15} />
							<Box
								styles={{
									alignItems: 'baseline',
									marginTop: rem(14),
								}}
							>
								<Box
									styles={{
										marginRight: rem(24),
										height: '100%',
									}}
								>
									{!canRequestNewCode ? (
										<ComposableTypography
											baseProps={{ appearance: 'microcopy-75-02' }}
											text={resources.message}
											tags={{
												timeBold: { appearance: 'microcopy-75-04' },
											}}
										/>
									) : (
										<Link
											onClick={() => {
												requestAuthentication();
											}}
										>
											<Typography appearance="microcopy-100-03" colorToken="interaction-01-100">
												{resources.askAnotherCode}
											</Typography>
										</Link>
									)}
								</Box>
								<Box>
									<Button
										appearance="primary"
										size="medium"
										disabled={buttonDisableValidate}
										onPress={onButtonClick}
									>
										{resources.validateButton}
									</Button>
								</Box>
							</Box>
						</Box>
					</Box>
				</Box>
			)}
			{!authenticationMessageLoading && !showAuthentication && (
				<Box
					styles={{
						alignItems: 'center',
						justifyContent: 'space-between',
						width: '100%',
						margin: rem(0, 80),
					}}
				>
					<Box
						styles={{
							flexGrow: '10',
						}}
					>
						<Link onClick={onClickToNavigate}>
							<Typography appearance="body-100-03" colorsLevel="linkDefault">
								{resources.linkBack}
							</Typography>
						</Link>
					</Box>
					<Box
						styles={{
							alignItems: 'center',
							justifyContent: 'space-around',
							flexGrow: '1',
						}}
					>
						<Box
							styles={{
								flexDirection: 'column',
								marginBottom: rem(4),
							}}
						>
							<div>
								<Typography appearance="body-100-04">{resources.title}</Typography>
							</div>
							<div>
								<Typography appearance="microcopy-75-02">{resources.subtitle}</Typography>
							</div>
						</Box>
						<Box>
							{authenticationTypeLoading ? (
								<Skeleton variant={'light'} width={69.46} height={42} borderRadius={100} />
							) : (
								<Button appearance="primary" onPress={requestAuthentication}>
									{resources.typeAuthenticationSMS}
								</Button>
							)}
						</Box>
					</Box>
				</Box>
			)}
		</Box>
	);
};
